
  import { Integration as IntegrationType } from '@/services/integrations/types';
  import { useIntegrationsHomeStore } from '@/stores/integrationsHome';
  import { computed, defineComponent } from 'vue';
  import _ from 'lodash';
  import Integration from './Integration.vue';
  import NavbarHome from './NavbarHome.vue';
  import UpgradeAlert from '../UpgradeAlert.vue';

  interface IntegrationGroup {
    category: string;
    integrations: IntegrationType[];
  }

  export default defineComponent({
    name: 'ListingContents',
    components: {
      Integration,
      NavbarHome,
      UpgradeAlert,
    },
    setup() {
      const store = useIntegrationsHomeStore();

      const integrationsGrouped = computed<Array<IntegrationGroup>>(() => {
        const integrations = store.selectedIntegrations;
        return _(integrations).groupBy('category').toPairs().map(([category, integrations]) => ({
          category,
          integrations,
        })).value();
      });

      const loading = computed(() => store.loading);
      const shouldShowUpgradeAlert = computed(() => store.shouldShowUpgradeAlert);

      return {
        integrationsGrouped,
        loading,
        shouldShowUpgradeAlert,
      };
    },
  });
